import { render, staticRenderFns } from "./ds-pagination-bar.vue?vue&type=template&id=dccff464&scoped=true"
import script from "./ds-pagination-bar.vue?vue&type=script&lang=js"
export * from "./ds-pagination-bar.vue?vue&type=script&lang=js"
import style0 from "./ds-pagination-bar.vue?vue&type=style&index=0&id=dccff464&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dccff464",
  null
  
)

export default component.exports